import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchConsultaAssinaturaComponent } from './switch-consulta-assinatura.component';

@NgModule({
  declarations: [
    SwitchConsultaAssinaturaComponent
  ],
  imports: [
    CommonModule,
    
  ],
  exports: [SwitchConsultaAssinaturaComponent]
})
export class SwitchConsultaAssinaturaModule { }
